import React from "react";
import { useHistory } from "react-router-dom";

const ContactUs = () => {
  const history = useHistory();

  const styles = {
    container: {
      minHeight: "100vh",
      backgroundColor: "#f5f5f5",
      padding: "20px",
      overflowY: "auto",
      height: "100vh",
    },
    contentWrapper: {
      maxWidth: "900px",
      margin: "0 auto",
      backgroundColor: "#ffffff",
      padding: "25px",
      borderRadius: "8px",
      boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
    },
    header: {
      textAlign: "center",
      marginBottom: "30px",
      paddingBottom: "20px",
      borderBottom: "2px solid #e0e0e0",
      display: "flex",
      alignItems: "center",
      gap: "10px",
    },
    title: {
      fontSize: "24px",
      fontWeight: "bold",
      color: "#333",
      marginBottom: "10px",
    },
    paragraph: {
      fontSize: "14px",
      lineHeight: "1.4",
      color: "#666",
      marginBottom: "15px",
      textAlign: "justify",
    },
    contactCard: {
      backgroundColor: "#f8f9fa",
      padding: "20px",
      borderRadius: "8px",
      boxShadow: "0 1px 6px rgba(0,0,0,0.08)",
    },
    label: {
      fontWeight: "600",
      color: "#333",
    },
    value: {
      marginBottom: "10px",
      color: "#555",
    },
    backButton: {
      cursor: "pointer",
      color: "#007bff",
      textDecoration: "none",
      boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
      height: "40px",
      width: "40px",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "18px",
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.contentWrapper}>
        <div style={styles.header}>
          <div style={styles.backButton} onClick={() => history.goBack()}>
            <i className="mdi mdi-keyboard-backspace"></i>
          </div>
          <h1 style={styles.title}>Contact Us</h1>
        </div>

        <p style={styles.paragraph}>
          We'd love to hear from you. For questions related to subscriptions,
          exams, refunds, or general platform feedback, reach out through the
          following channels and our support team will respond as quickly as
          possible.
        </p>

        <div style={styles.contactCard}>
          <p style={{ ...styles.value, marginBottom: "5px" }}>
            <span style={styles.label}>Name:</span> Mrs. Pushpaben Patel
          </p>
          <p style={{ ...styles.value, marginBottom: "5px" }}>
            <span style={styles.label}>Company:</span> AdhyayanYatra EduTech LLP
          </p>
          <p style={{ ...styles.value, marginBottom: "5px" }}>
            <span style={styles.label}>Address:</span> 223, Akodara, Himatnagar,
            Sabarkantha, Gujarat 383001
          </p>
          <p style={{ ...styles.value, marginBottom: "5px" }}>
            <span style={styles.label}>Website:</span>{" "}
            <a href="https://www.adhyayanyatra.com" target="_blank" rel="noreferrer">
              www.adhyayanyatra.com
            </a>
          </p>
          <p style={{ ...styles.value, marginBottom: "5px" }}>
            <span style={styles.label}>Email:</span>{" "}
            <a href="mailto:support@adhyayanyatra.com">
              support@adhyayanyatra.com
            </a>
          </p>
          <p style={{ ...styles.value, marginBottom: "0" }}>
            <span style={styles.label}>Phone:</span> +91 9408770877
          </p>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;

